import request from '@/utils/request';
import { PrintRequest } from '@/pages/PrintRequest/printRequest.data';
import type { FetchUpgradeRequestResp } from '@/pages/UpgradeRequest/upgradeRequest.data';

export async function createPrintRequest(params: any): Promise<PrintRequest> {
  return request.post(`/print-request`, {
    data: params,
  });
}

export async function vnPayReturnUrlCheck(params?: any): Promise<any> {
  return request.get(`/payment/vnpay/Return${params}`);
}

export async function zaloPayReturnUrlCheck(params?: any): Promise<any> {
  return request.get(`/payment/zalopay/Return${params}`);
}

export async function zaloPayRefund(id: string): Promise<any> {
  return request.post(`/payment/zalopay/refund/${id}`);
}

export async function fetchPrintRequests(params?: any): Promise<FetchUpgradeRequestResp> {
  return request.get(`/print-request`, {
    params,
  });
}

export async function updatePrintRequest(id: string, params: any) {
  return request.patch(`/print-request/${id}`, {
    data: params,
  });
}
